import React, { PureComponent } from "react";
import { Redirect, Link } from "react-router-dom";
import {
    Button,
    Row,
    Col,
    Input,
    Form,
    Alert,
    message,
    Skeleton,
    Space,
    Select,
    Spin,
    Table,
    notification,
    DatePicker,
    Modal,
    Radio
} from "antd";
import "@ant-design/compatible/assets/index.css";

import Config from "../../../Config"

import { connect } from "react-redux";
import { setConfig, ajaxHandler, ajaxViewHandler } from "../../../store/actions";

import "antd/dist/antd.css";
// import TambahKota from "./TambahKota";
// import EditKota from "./EditKota";
import moment from 'moment';
import 'moment/locale/id'; // Impor paket bahasa Indonesia

var configClass = {
    apiUrl: {
        detailPerush: "/api/v1.0/pusat/e-service/kantor-cabang/detail-perusahaan/",
        detailKantor: "/api/v1.0/pusat/e-service/kantor-cabang/detail-kantor/",
        detailPerub: "/api/v1.0/pusat/e-service/kantor-cabang/detail-perubahan/",
    },
};
class DetailKantor extends PureComponent {
    config;
    timeoutGetQr;
    timeOutPushQr;
    formRef = React.createRef();

    constructor(props) {
        super(props);
        this.config = new Config();
        this.state = {
            errMsg: "",
            loadingPerub: false,
            loadingPerush: false,
            loadingKantor: false,

            pagination: { pageSize: 10 },
            searchText: "",
            searchColumn: "",
            showDetailError: false,
            dataPerub: [],

            namaPerush: "",
            alamatPerush: "",
            noSiup: "",
            tglSiup: "",

            kc_alamat: "",
            kc_notelp: '',
            kc_nofax: '',
            kc_namakacab: '',
            kc_alamatkacab: '',
            kc_notelpkacab: '',
            kc_noskkacab: '',
            kc_tglsk: '',
            kc_cat: '',
            kc_tglaktif: '',
            kc_nomohon: '',
            kc_tglmohon: '',
            kc_npwp: '',
            kc_nosrtmasuk: '',
            kc_tglsrtmasuk: '',
            kc_nosrtkeluar: '',
            kc_tglsrtkeluar: '',
            kc_kpflag: '',
            kc_aktif: '',
            kc_kota: '',
            kc_prop: '',
            kc_pelabuhan: '',

            columns: [
                {
                    title: "Alamat KC Lama",
                    dataIndex: "alamat_kc_lama",
                    key: "alamat_kc_lama",
                },
                {
                    title: "Alamat KC Baru",
                    dataIndex: "alamat_kc_baru",
                    key: "alamat_kc_baru",
                },
                {
                    title: "Nama KaCab Lama",
                    dataIndex: "nama_kacab_lama",
                    key: "nama_kacab_lama",
                },
                {
                    title: "Nama KaCab Baru",
                    dataIndex: "nama_kacab_baru",
                    key: "nama_kacab_baru",
                },
                {
                    title: "No Telp KaCab Lama",
                    dataIndex: "no_telp_kacab_lama",
                    key: "no_telp_kacab_lama",
                },
                {
                    title: "No Telp KaCab Baru",
                    dataIndex: "no_telp_kacab_baru",
                    key: "no_telp_kacab_baru",
                },
                {
                    title: "NPWP KaCab Lama",
                    dataIndex: "npwp_kacab_lama",
                    key: "npwp_kacab_lama",
                },
                {
                    title: "NPWP KaCab Baru",
                    dataIndex: "npwp_kacab_baru",
                    key: "npwp_kacab_baru",
                },
                {
                    title: "Alamat KaCab Lama",
                    dataIndex: "alamat_kacab_lama",
                    key: "alamat_kacab_lama",
                },
                {
                    title: "Alamat KaCab Baru",
                    dataIndex: "alamat_kacab_baru",
                    key: "alamat_kacab_baru",
                },
            ],
            dataDetail: null,
            filter: "",
        };
    }


    UNSAFE_componentWillMount() { }

    async componentDidMount() { }

    componentDidUpdate(prevProps) {
        if (prevProps.id !== this.props.id) {
            this.getDataPerubahan();
            this.getDataKantor();
            this.getDataPerush();

        }
    }

    removeTab = targetKey => {
        // console.log("masuk sini")
        var tempTabs = this.props.tabs;
        const index_cari = tempTabs.findIndex((data) => data.key == targetKey);
        var activeKey = "";
        if (index_cari != -1) {
            activeKey = tempTabs[index_cari - 1].key
            tempTabs.splice(index_cari, 1);
        }
        // alert(activeKey);
        this.props.setConfig({
            tabs: tempTabs,
            activeKey: activeKey
        });
    };

    tabProses(tabData) {
        const key = tabData.key;
        var tempTabs = this.props.tabs;
        var isExist = false;
        tempTabs.map((item) => {
            if (item.key == key) {
                isExist = true;
            }
        });
        if (isExist) {
            this.props.setConfig({
                activeKey: tabData.key,
            });
        } else {
            tempTabs = [
                ...tempTabs,
                {
                    title: tabData.title,
                    content: tabData.content,
                    key: tabData.key,
                },
            ];
            this.props.setConfig({
                tabs: tempTabs,
                activeKey: tabData.key,
            });
        }
    }

    async getDataPerubahan() {
        this.setState({
            loadingPerub: true,
            errTitle: "",
            errMsg: "",
            showDetailError: false,
            dataPerub: []
        });
        // console.log(stateName, url);

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detailPerub + this.props.id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    const pagination = { ...this.state.pagination };
                    pagination.total = data.responseData.attributes.total;
                    var dataItem = data.responseData.items;
                    this.setState({
                        dataPerub: dataItem,
                        pagination,
                    });
                    // console.log("getData", this.state.dataPerub);

                } else {
                    const errTitle = "failed get data";
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(this.props.responseMsg),
                        placement: "bottomRight",
                    });
                }

                this.setState({ loadingPerub: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingPerub: false });
            });
    }

    async getDataPerush() {
        this.setState({
            loadingPerush: true,
        });

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detailPerush + this.props.id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    var dataItem = data.responseData.items;
                    this.setState({
                        namaPerush: dataItem[0].nama_perusahaan,
                        alamatPerush: dataItem[0].alamat,
                        noSiup: dataItem[0].no_siup,
                        tglSiup: moment(dataItem[0].tgl_siup).locale('id').format("DD MMMM YYYY")
                    });
                    // console.log("getDataPerush", dataItem);

                } else {
                    const errTitle = "failed get data";
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(this.props.responseMsg),
                        placement: "bottomRight",
                    });
                }
                this.setState({ loadingPerush: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingPerush: false });
            });
    }

    async getDataKantor() {
        this.setState({
            loadingKantor: true,
        });

        this.props
            .ajaxViewHandler("get", configClass.apiUrl.detailKantor + this.props.id)
            .then(() => {
                const data = this.props.responseMsg;
                if (this.props.isSuccess) {
                    var dataItem = data.responseData.items;
                    this.setState({
                        kc_alamat: dataItem[0].alamat,
                        kc_notelp: dataItem[0].no_telepon,
                        kc_nofax: dataItem[0].no_fax,
                        kc_namakacab: dataItem[0].nama_kepala_cabang,
                        kc_alamatkacab: dataItem[0].alamat_kepala_cabang,
                        kc_notelpkacab: dataItem[0].no_telepon_kepala_cabang,
                        kc_noskkacab: dataItem[0].no_sk_pengangkatan,
                        kc_tglsk: moment(dataItem[0].tgl_sk_pengangkatan).locale('id').format("DD MMMM YYYY"),
                        kc_cat: dataItem[0].catatan,
                        kc_tglaktif: moment(dataItem[0].tgl_aktif).locale('id').format("DD MMMM YYYY"),
                        kc_nomohon: dataItem[0].no_permohonan,
                        kc_tglmohon: moment(dataItem[0].tgl_permohonan).locale('id').format("DD MMMM YYYY"),
                        kc_npwp: dataItem[0].npwp,
                        kc_nosrtmasuk: dataItem[0].no_suratmasuk,
                        kc_tglsrtmasuk: moment(dataItem[0].tgl_suratmasuk).locale('id').format("DD MMMM YYYY"),
                        kc_nosrtkeluar: dataItem[0].no_suratkeluar,
                        kc_tglsk: moment(dataItem[0].tgl_suratkeluar).locale('id').format("DD MMMM YYYY"),
                        kc_kpflag: dataItem[0].kantor_pusat_flag,
                        kc_aktif: dataItem[0].active_flag == "Y" ? "Aktif" : "Tidak Aktif",
                        kc_kota: dataItem[0].nama_kota,
                        kc_prop: dataItem[0].nama_propinsi,
                        kc_pelabuhan: dataItem[0].nama_pelabuhan,
                    });
                    // console.log("getDataKantor", dataItem);

                } else {
                    const errTitle = "failed get data";
                    notification.error({
                        message: errTitle,
                        description: JSON.stringify(this.props.responseMsg),
                        placement: "bottomRight",
                    });
                }
                this.setState({ loadingKantor: false });
            })
            .catch((response) => {
                // console.log("gagal_get_preview", response);
                notification.error({
                    message: "gagal_get_preview",
                    description: JSON.stringify(response),
                    placement: "bottomRight",
                });
                this.setState({ loadingKantor: false });
            });
    }
    // filterData(values) {
    //     var filter = "";
    //     for (var key in values) {
    //         if (values[key] != undefined) {
    //             filter += "&" + key + "=" + values[key];
    //         }
    //     }
    //     console.log("filter", filter)

    //     this.setState({
    //         filter: filter,
    //         pagination: { pageSize: 10, current: 1 },
    //     }, () => {
    //         this.getData(this.state.pagination.pageSize, 1)
    //     });
    // }

    handleTableChange = async (pagination, filters, sorter) => {
        const newPagination = { ...this.state.pagination };
        newPagination.pageSize = pagination.pageSize;
        this.setState({
            loadingData: true,
            pagination,
        });
        if (pagination.current == 1) {
            this.getData(pagination.pageSize);
        } else {
            this.getData(
                pagination.pageSize,
                pagination.current
                // (pagination.current - 1) * pagination.pageSize
            );
        }
    };

    // handleClear() {
    //     this.setState({
    //         filter: ""
    //     }, () => {
    //         this.formRef.current.resetFields();
    //         this.getData(this.state.pagination.pageSize, 1);
    //     });
    // }

    render() {
        return (
            <>
                <style>
                    {`
                    .data-row:nth-child(odd) {background-color: #f5f5f5;}
                    .label-with-spacing {margin-left: 8px;} 
                    `}
                </style>
                {/*<!-- Tab Content -->*/}
                <div className="row tab-content">
                    {/*<!-- Tab Beranda -->*/}
                    <div className="col-12">
                        <Spin
                            size="large"
                            spinning={this.state.loadingPerush}
                            tip={<span style={{ color: "#000" }}>loading...</span>}
                        >
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-tittle">DATA PERUSAHAAN</h4>
                                            <a className="heading-elements-toggle">
                                                <i className="la la-ellipsis-v font-medium-3"></i>
                                            </a>
                                            <div className="heading-elements">
                                                <ul className="list-inline mb-0">
                                                    <li>
                                                        <a data-action="expand">
                                                            <i className="ft-maximize"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a data-action="collapse">
                                                            <i className="ft-plus"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="card-content collapse show">
                                            <div className="card-body">
                                                <div className="form-body">
                                                    <Row className="data-row">
                                                        <Col span={4}><label className="col-md-12 label-control">Nama Perusahaan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.namaPerush}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={4}><label className="col-md-12 label-control">No SIUP</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.noSiup}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={4}><label className="col-md-12 label-control">Tanggal SIUP</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.tglSiup}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={4}><label className="col-md-12 label-control">Alamat</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.alamatPerush}</label></Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                    <div className="col-12">
                        <Spin
                            size="large"
                            spinning={this.state.loadingKantor}
                            tip={<span style={{ color: "#000" }}>loading...</span>}
                        >
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-header">
                                            <h4 className="card-tittle">DATA KANTOR</h4>
                                            <a className="heading-elements-toggle">
                                                <i className="la la-ellipsis-v font-medium-3"></i>
                                            </a>
                                            <div className="heading-elements">
                                                <ul className="list-inline mb-0">
                                                    <li>
                                                        <a data-action="expand">
                                                            <i className="ft-maximize"></i>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a data-action="collapse">
                                                            <i className="ft-miplusnus"></i>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div className="card-content collapse show">
                                            <div className="card-body">
                                                <div className="form-body">
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Alamat Kantor Cabang</label></Col>
                                                        {(this.state.kc_alamat != '' &&
                                                            <Col span={16}>
                                                                <label className="col-md-12 label-control">: {this.state.kc_alamat}</label>
                                                                <label className="col-md-12 label-control label-with-spacing">Kota {this.state.kc_kota}</label>
                                                                <label className="col-md-12 label-control label-with-spacing">Propinsi {this.state.kc_prop}</label>
                                                            </Col>
                                                        )}
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Pelabuhan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_pelabuhan}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Telepon</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_notelp}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Fax</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_nofax}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nama Kepala Cabang</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_namakacab}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Alamat Kepala Kantor Cabang</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_alamatkacab}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Telepon Kepala Kantor Cabang</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_notelpkacab}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">No. SK Pengangkatan Kepala Kantor Cabang</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_noskkacab}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal SK Pengangkatan Kepala Kantor Cabang</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_tglsk}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Catatan </label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_cat}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal Aktif</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_tglaktif}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Permohonan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_nomohon}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal Permohonan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_tglmohon}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">NPWP </label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_npwp}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Surat Masuk</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_nosrtmasuk}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal Surat Masuk</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_tglsrtmasuk}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Nomor Surat Keluar</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_nosrtkeluar}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Tanggal Surat Keluar</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_tglsrtkeluar}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Kantor Pusat?</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_kpflag}</label></Col>
                                                    </Row>
                                                    <Row className="data-row">
                                                        <Col span={6}><label className="col-md-12 label-control">Status Keaktifan</label></Col>
                                                        <Col span={16}><label className="col-md-12 label-control">: {this.state.kc_aktif}</label></Col>
                                                    </Row>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Spin>
                    </div>
                    <div className="col-12" id="berkas">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4 className="card-tittle">PERUBAHAN KANTOR CABANG</h4>
                                    </div>
                                    <div className="card-content collapse show">
                                        <div className="card-body">
                                            {(this.state.errMsg != null && this.state.errMsg != "" &&
                                                <Alert
                                                    message={this.state.errTitle}
                                                    description={
                                                        <div>
                                                            {this.state.showDetailError == true
                                                                ?
                                                                JSON.stringify(this.state.errMsg)
                                                                :
                                                                "gagal mendapatkan response server, cobalah beberapa saat lagi"
                                                            }
                                                        </div>
                                                    }
                                                    // description={JSON.stringify(this.state.errMsg)}
                                                    type="error"
                                                    showIcon
                                                    closable
                                                    style={{
                                                        marginBottom: 10,
                                                    }}
                                                    action={
                                                        <Space direction="vertical">
                                                            <Button size="small" type="primary" onClick={() => this.getData(this.state.pagination.pageSize, 1)}>
                                                                Try Again
                                                            </Button>
                                                            <Button
                                                                size="small"
                                                                danger
                                                                type="ghost"
                                                                onClick={() => {
                                                                    const recentValue = this.state.showDetailError;
                                                                    this.setState({
                                                                        showDetailError: !recentValue
                                                                    })
                                                                }}
                                                            >
                                                                {this.state.showDetailError == true ? "Hide Error Detail" : "Show Error Detail"}
                                                            </Button>
                                                        </Space>
                                                    }
                                                />
                                            )}
                                            <div className="table-responsive">
                                                <Table
                                                    // style={{margin: 10}}
                                                    title={() => (
                                                        <Row>
                                                            <Col lg={8} sm={24} xs={24}>
                                                                <span className="konten-judul">
                                                                    Total {this.state.pagination.total} record
                                                                </span>
                                                            </Col>
                                                        </Row>
                                                    )}
                                                    rowKey="alamat_kc_lama"
                                                    bordered
                                                    columns={this.state.columns}
                                                    dataSource={this.state.dataPerub}
                                                    loading={this.state.loadingPerub}
                                                    // scroll={{ x: 500, y: 600 }}
                                                    size="small"
                                                    pagination={this.state.pagination}
                                                    onChange={this.handleTableChange}
                                                    className="table table-bordered table-striped mb-0"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/*<!-- end berkas -->*/}
                    </div>
                    {/*<!-- End Tab Beranda -->*/}
                </div >
                {/*<!-- End Tab Beranda -->*/}
            </>
        );
    }
}

const mapStateToProps = function (state) {
    return state.configReducers;
};

export default connect(mapStateToProps, {
    setConfig,
    ajaxHandler,
    ajaxViewHandler,
})(DetailKantor);
